export class PageRequest {
  size: number;
  page: number;
  sortProperty?: string[] | string;
  sortDirection?: string;
}
